import React from 'react';
import PropTypes from 'prop-types';

import ExternalLink from 'components/Widgets/ExternalLink';
import IconWithText from 'components/Widgets/IconWithText';

export default function Header({ coach }) {
  return (
    <div className="mb-5 text-center">
      <img
        src={coach.attributes.avatar_url}
        alt={coach.attributes.full_name}
        width="248"
        height="248"
        className="rounded-4"
      />

      <div className="d-flex justify-content-center mt-4">
        {coach.attributes.website_link && (
          <ExternalLink
            href={coach.attributes.website_link}
            variant={null}
            className="me-3"
          >
            <IconWithText iconClassName="web-icon small-icon" />
          </ExternalLink>
        )}

        {coach.attributes.linkedin_link && (
          <ExternalLink
            href={coach.attributes.linkedin_link}
            variant={null}
            className="me-3"
          >
            <IconWithText iconClassName="linkedin-icon small-icon" />
          </ExternalLink>
        )}

        {coach.attributes.twitter_link && (
          <ExternalLink
            href={coach.attributes.twitter_link}
            variant={null}
            className="me-3"
          >
            <IconWithText iconClassName="twitter-icon small-icon" />
          </ExternalLink>
        )}

        {coach.attributes.youtube_link && (
          <ExternalLink
            href={coach.attributes.youtube_link}
            variant={null}
          >
            <IconWithText iconClassName="youtube-icon small-icon" />
          </ExternalLink>
        )}
      </div>

      <div className="d-md-none my-4">
        <h6 className="mb-3">
          About Me
        </h6>

        <p>{coach.attributes.introduction_text}</p>
      </div>
    </div>
  );
}

Header.propTypes = {
  coach: PropTypes.object.isRequired,
};
